var React = require('react');

function ArrowReturn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.81445 47.2014L5.91743 35.9899","stroke":"#6335CC","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M17.5501 35.8759L5.91514 35.9896","stroke":"#6335CC","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M6.01172 12.7022C9.99928 6.02478 17.2975 1.55298 25.6401 1.55298C38.2574 1.55298 48.4857 11.7813 48.4857 24.3985C48.4857 37.0158 38.2574 47.2441 25.6401 47.2441C17.2975 47.2441 9.99928 42.7723 6.01172 36.0949","stroke":"#6335CC","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":2})]);
}

ArrowReturn.defaultProps = {"width":"50","height":"49","viewBox":"0 0 50 49","fill":"none"};

module.exports = ArrowReturn;

ArrowReturn.default = ArrowReturn;
